const AUTH_TOKEN_KEY = 'authToken';

export const authStorage = {
  getToken: () => sessionStorage.getItem(AUTH_TOKEN_KEY),
  setToken: (token: string) => sessionStorage.setItem(AUTH_TOKEN_KEY, token),
  removeToken: () => sessionStorage.removeItem(AUTH_TOKEN_KEY),
};

export { AUTH_TOKEN_KEY };
